import { type JSX, ReactNode } from 'react';
import { Route } from 'react-router';
import { FrostedGate } from '../../../components/FrostedGate/FrostedGate';
import { Loader } from '../../../components/Loader/Loader';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { lazyPage } from '../../../util/lazyPage';
import { useDealsTabState } from './useDealsTabEnabled';

const DealsTab = lazyPage(() => import('./DealsTab'), 'DealsTab');
const DealsTabPreview = lazyPage(() => import('./DealsTabPreview'), 'DealsTabPreview');

/** Route element for the Deals tab. The plan check lives here, not in the route tree, so
 *  only this route waits on the site's plan. */
export function DealsTabRoute({ fallback }: { fallback: ReactNode }) {
  const isEnabled = useDealsTabState();

  if (isEnabled === undefined) {
    return <Loader />;
  }
  if (!isEnabled) {
    return fallback;
  }

  return (
    <FrostedGate target='deals' preview={<DealsTabPreview />}>
      <DealsTab />
    </FrostedGate>
  );
}

/** Shared by the standard and auditor route sets so both follow the same Deals tab gate. */
export function getDealsRoute(permSvc: PermissionService, notAllowed: ReactNode): JSX.Element {
  return permSvc.hasPermission(PermissionKey.canViewMetrics) ? (
    <Route key='deals' path={ROUTES.DEALS} element={<DealsTabRoute fallback={notAllowed} />} />
  ) : (
    <Route key='deals-blocked' path={`${ROUTES.DEALS}/*`} element={notAllowed} />
  );
}
